import { render, staticRenderFns } from "./batchUpdateFaceIdentifyDialog.vue?vue&type=template&id=3f8a6d29&scoped=true"
import script from "./batchUpdateFaceIdentifyDialog.vue?vue&type=script&lang=js"
export * from "./batchUpdateFaceIdentifyDialog.vue?vue&type=script&lang=js"
import style0 from "./batchUpdateFaceIdentifyDialog.vue?vue&type=style&index=0&id=3f8a6d29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8a6d29",
  null
  
)

export default component.exports